import { useMutation } from '@tanstack/react-query';
import { useApi } from 'hooks';

type Payload = {
  phone_number: string;
};

export const usePatchPublicUser = () => {
  const { api } = useApi();

  const mutation = useMutation({
    mutationFn: ({ userId, payload }: { userId: string; payload: Payload }) => {
      return api({
        route: `/user/${userId}/`,
        method: 'PATCH',
        payload,
      });
    },
  });

  return {
    mutation,
  };
};

export default usePatchPublicUser;
